export const comments_5256812 = {"data":{"data":[],"links":{}}}